module.exports = __webpack_public_path__ + "static/media/Flash-Love.dab8613e.jpg";